module.exports = __webpack_public_path__ + "static/media/FONDO50.021e0a70.png";